import React from 'react';
import { NavLink } from 'react-router-dom';
import { HiOutlinePencilAlt, HiOutlineClock, HiOutlineCollection, HiOutlineUserCircle, HiOutlineQuestionMarkCircle, HiOutlineDocumentText, HiOutlineCreditCard, HiOutlineClipboardCheck, HiOutlineTicket, HiOutlineChartBar } from 'react-icons/hi';
import { useAuth } from '../../context/AuthContext';

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
    const { user } = useAuth();
    // Use the same logic as in OrderRequest.jsx for role check
    const isKTEManagement = (user?.role === 'KTE-management' || user?.accountType === 'KTE-management');
    const isSupplier = (user?.role === 'Supplier' || user?.accountType === 'Supplier');
    const isKTESales = (user?.role === 'KTE-sales' || user?.accountType === 'KTE-sales');
    const isKTEEmployee = (user?.role === 'KTE-Employees' || user?.accountType === 'KTE-Employees');

    const allowedDiscountUsers = ['mohammed_ali', 'mohammed_jabali'];
    const canViewDiscounts = user?.username && allowedDiscountUsers.includes(user.username);

    let navItems;
    if (isKTEManagement) {
        navItems = [
            { path: '/management/overview', label: 'Overview', icon: <HiOutlineChartBar /> },
            { path: '/management/pending-orders', label: 'Pending Orders', icon: <HiOutlineClock /> },
            { path: '/management/money-deposit', label: 'Money Deposit', icon: <HiOutlineDocumentText /> },
            { path: '/management/preparing-orders', label: 'Preparing Orders', icon: <HiOutlineClipboardCheck /> },
            { path: '/management/scratch-orders-management', label: 'Scratch Orders Management', icon: <HiOutlineCreditCard /> },
            { path: '/management/clients', label: 'Client Management', icon: <HiOutlineUserCircle /> },
            { path: '/management/all-orders', label: 'Orders Collection', icon: <HiOutlineCollection /> },
        ];
        if (canViewDiscounts) {
            navItems.push({ path: '/management/discounts', label: 'Discounts', icon: <HiOutlineTicket /> });
        }
    } else if (isKTESales) {
        navItems = [];
        if (canViewDiscounts) {
            navItems.push({ path: '/management/discounts', label: 'Discounts', icon: <HiOutlineTicket /> });
        }
    } else if (isSupplier) {
        navItems = [
            { path: '/supplier/pending-orders', label: 'Pending Orders', icon: <HiOutlineClock /> },
            { path: '/supplier/order-history', label: 'Order History', icon: <HiOutlineCollection /> },
        ];
    } else if (isKTEEmployee) {
        navItems = [
            { path: '/order-request', label: 'Order Request', icon: <HiOutlinePencilAlt /> },
            { path: '/pending-orders', label: 'Pending Orders', icon: <HiOutlineClock /> },
            { path: '/all-orders', label: 'All Orders', icon: <HiOutlineCollection /> },
            { path: '/employee/scratch-orders-management', label: 'Scratch Orders Management', icon: <HiOutlineCreditCard /> },
            { path: '/account-info', label: 'Account Info', icon: <HiOutlineUserCircle /> },
            { path: '/help', label: 'Get Help', icon: <HiOutlineQuestionMarkCircle /> },
        ];
    } else {
        navItems = [
            { path: '/order-request', label: 'Order Request', icon: <HiOutlinePencilAlt /> },
            { path: '/pending-orders', label: 'Pending Orders', icon: <HiOutlineClock /> },
            { path: '/all-orders', label: 'All Orders', icon: <HiOutlineCollection /> },
            { path: '/account-info', label: 'Account Info', icon: <HiOutlineUserCircle /> },
            { path: '/help', label: 'Get Help', icon: <HiOutlineQuestionMarkCircle /> },
        ];
    }

    return (
        <>
            {/* Overlay for mobile - moved outside sidebar */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                    aria-hidden="true"
                />
            )}

            <aside
                className={`fixed inset-y-0 left-0 z-50 w-64 bg-white min-h-screen flex flex-col transform transition-transform duration-300 ease-in-out
                    ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
                    lg:static lg:translate-x-0 lg:z-auto shadow-lg`}
            >
                <div className="bg-white p-4 flex items-center justify-center">
                    <img src="/logo.webp" alt="Dealers Portal Logo" className="w-14 object-contain mr-2" />
                    <h1 className="text-xl font-bold text-gray-800">
                        {isSupplier ? (
                            <>
                                <span className="text-orange-500">Supplier</span> Portal
                            </>
                        ) : (
                            'Dealers Portal'
                        )}
                    </h1>
                </div>
                <nav className="mt-6 flex-1 overflow-y-auto">
                    <div className="px-4 space-y-2">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={({ isActive }) =>
                                    `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${isActive
                                        ? 'bg-blue-500 text-white shadow-md'
                                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                                    }`
                                }
                                onClick={() => setSidebarOpen(false)}
                            >
                                <span className="mr-4 text-lg">{item.icon}</span>
                                {item.label}
                            </NavLink>
                        ))}
                    </div>
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;